const PocketBase = require('pocketbase/cjs')

export const pb = new PocketBase(process.env.VUE_APP_POCKETBASE_URL);
